import axios from "axios";
import { baseEnvironment } from "../environment/environment.base";

const surgeryFormsDownloadRoute = `${baseEnvironment.apiVersion3}${baseEnvironment.apiEndPoints.surgeryForms.downloadForm}`;

export const downloadForm = async (code: string): Promise<any> => {
    const url = surgeryFormsDownloadRoute.replace(":uuid", code)
    const response = await axios.get(url);
    return response;
}